
<template>
  <div>
    <b-overlay
      :show="show"
      :variant="variant"
      :opacity="opacity"
      :blur="blur"
      rounded="lg"
      spinner-variant="primary"
    >
      <b-card>
        <h1>{{ $t("EditProfile") }}</h1>

        <form method="post" v-on:submit.prevent="$event.preventDefault()">
          <div class="vx-row images">
            <div class="vx-col w-1/2 mt-5">
              <div class="items-start">
                <label class="vs-input--label">{{ $t("ProfileImage") }}</label>
                <div>
                  <!-- Toggle comment of below buttons as one for actual flow & currently shown is only for demo -->
                  <div class="main" :style="bgColor">
                    <div
                      class="dropzone-container"
                      @dragover="dragover"
                      @dragleave="dragleave"
                      @drop="drop"
                      :style="isDragging && 'border-color: green;'"
                    >
                    <img :src="url || errorImage" class="mr-8 rounded h-24 w-24" />

                    <div class="mt-2">
                    <input
                        type="file"
                        ref="file"
                        class="hidden"
                        accept="image/*"
                        name="file"
                        id="fileInput"
                        @change="onChange"
                        />

                      <label for="fileInput" class="file-label">
                        <div><b>{{$t('chooseFile')}}</b> {{$t('dragit')}}</div>
                      </label>
                    </div>
                  </div>
                  </div>
                  <!-- <vs-button type="border" color="danger">Remove</vs-button> -->
                </div>
              </div>
            </div>

            <div class="vx-col w-1/2 mt-2" v-if="crop.src.length">
              <cropper
                id="profile_image"
                ref="cropper"
                class="cropper"
                :src="crop.src"
                :auto-zoom="true"
                :stencil-size="{
                  width: 250,
                  height: 250,
                }"
                image-restriction="stencil"
              />
              <div class="button-wrapper">
                <button
                  class="btn border-primary btn-primary"
                  @click="cropImage"
                >
                  {{ $t("CropImage") }}
                </button>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <!-- required -->
            <div
              class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-5"
            >
              <label class="vs-input--label"
                >{{ $t("FirstName") }} <span class="red">*</span></label
              >

              <b-form-input
                size="lg"
                v-validate="'required|alpha'"
                :data-vv-as="$t('FirstName')"
                name="first_name"
                v-model="users.first_name"
                class="w-full"
                @keydown.enter="checkForm"
                :placeholder="$t('FirstName')"
              ></b-form-input>
              <span
                class="text-danger text-sm"
                v-show="errors.has('first_name')"
                >{{ errors.first("first_name") }}</span
              >
            </div>

            <!-- Must only consist of numbers -->
            <div
              class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-5"
            >
              <label class="vs-input--label"
                >{{ $t("LastName") }} <span class="red">*</span></label
              >

              <b-form-input
                size="lg"
                v-validate="'required|alpha'"
                :data-vv-as="$t('LastName')"
                name="last_name"
                v-model="users.last_name"
                class="w-full"
                @keydown.enter="checkForm"
                :placeholder="$t('LastName')"
              ></b-form-input>
              <span
                class="text-danger text-sm"
                v-show="errors.has('last_name')"
                >{{ errors.first("last_name") }}</span
              >
            </div>
            <!-- Must be a valid email -->
            <!-- Must only consist of numbers -->
            <div
              class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-5"
              id="contact_label"
            >
              <label class="vs-input--label"
                >{{ $t("ContactNumber") }} <span class="red">*</span></label
              >

              <vue-tel-input
                size="large"
                v-validate="{
                  required: true,
                  regex: /^(?=.*[0-9])[- +()0-9]+$/,
                  min: 12,
                }"
                v-model="users.contact_number"
                class="w-full contact_number"
                v-on:country-changed="countryChanged"
                v-bind="bindProps"
                v-on:blur="appendCode"
                @onInput="onInput"
                @keydown.enter="checkForm"
                :data-vv-as="$t('ContactNumber')"
                :placeholder="$t('ContactNumber')"
              ></vue-tel-input>

              <span
                id="phone"
                class="text-danger text-sm"
                v-show="errors.has('contact_number')"
                >{{ errors.first("contact_number") }}</span
              >
            </div>

            <div
              class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-5"
            >
              <label class="vs-input--label">{{ $t("Password") }}</label>

              <b-form-input
                type="password"
                size="lg"
                v-validate="'min:8|numbers|upCase|loCase'"
                ref="password"
                name="password"
                :data-vv-as="$t('Password')"
                v-model="newpassword"
                class="w-full"
                @keydown.enter="checkForm"
                :placeholder="$t('Password')"
                @input="displayError"
              ></b-form-input>
              <span
                class="text-danger text-sm"
                v-show="errors.has('password')"
                >{{ errors.first("password") }}</span
              >
            </div>

            <div
              class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-5"
            >
              <label class="vs-input--label">{{ $t("ConfirmPassword") }}</label>

              <b-form-input
                type="password"
                size="lg"
                v-validate="{
                  required: newpassword != '',
                  confirmed: newpassword,
                  min: 8,
                }"
                :data-vv-as="$t('ConfirmPassword')"
                name="confirm_password"
                v-model="confirm_password"
                class="w-full"
                @keydown.enter="checkForm"
                :placeholder="$t('ConfirmPassword')"
              ></b-form-input>
              <span
                class="text-danger text-sm"
                v-show="errors.has('confirm_password')"
                >{{ errors.first("confirm_password") }}</span
              >
            </div>
          </div>
          <div class="vx-col" id="update">
            <b-button
              type="filled"
              @click.prevent="handleSubmit"
              class="mt-5 block border-primary"
              variant="primary"
              >{{ $t("Save") }}</b-button
            >

            <router-link :to="'/admin/dashboard'">
              <b-button
                id="cancel"
                class="mt-5 br-20 pl-5 pr-5 border-primary text-primary"
                type="border"
                variant="border"
                >{{ $t("Cancel") }}</b-button
              >
            </router-link>
          </div>
        </form>
      </b-card>
    </b-overlay>
  </div>
</template>
<script>
import $ from "jquery";
// For custom error message
import { Validator } from "vee-validate";
import { phoneConfig } from "@/utils/helper";
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
//import DropFile from "@/components/DropFile.vue";

export default {
  components: {
    Cropper,
  },
  data() {
    return {
      users: [],
      newpassword: "",
      confirm_password: "",
      country: null,
      url: require("@/assets/images/portrait/small/avatar-s-271.png"),
      bindProps: phoneConfig(this.$t("ContactNumber")),
      error: "",
      success: "",
      sec: 2,
      show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      crop: {
        src: "",
        type: "image/jpg",
      },
      file_name: "",
      isDragging: false
    };
  },
  components: {
    Cropper,
  },
  watch: {
    "$i18n.locale": {
      handler: function (value) {
        this.loadLocale(value);
        this.displayError();
      },
    },
  },
  created() {
    this.$validator.extend("upCase", {
      getMessage: () => this.$t("errorMessage"),
      validate: (value) => value.match(/[A-Z]/g) !== null,
    });
    this.$validator.extend("numbers", {
      getMessage: () => this.$t("errorMessage"),
      validate: (value) => value.match(/[0-9]/g) !== null,
    });
    this.$validator.extend("loCase", {
      getMessage: () => this.$t("errorMessage"),
      validate: (value) => value.match(/[a-z]/g) !== null,
    });
    this.bindProps.disabledFetchingCountry = true;
    this.getUsers(this.$store.getters.currentUser.id);
    this.loadLocale(this.$i18n.locale);
  },
  mounted() {
    this.users = this.$store.getters.currentUser;
  },

  methods: {
    dragover(e) {
      e.preventDefault();
      this.isDragging = true;
    },
    dragleave() {
      this.isDragging = false;
    },
    drop(e) {
      e.preventDefault();
      this.$refs.file.files = e.dataTransfer.files;
      this.selectedFile(this.$refs.file.files[0]);
      this.isDragging = false;
    },
    onChange(event) {
        this.selectedFile(event.target.files[0]);
    },
    //display error
    displayError() {
      this.$validator.extend("upCase", {
        getMessage: () => this.$t("errorMessage"),
        validate: (value) => value.match(/[A-Z]/g) !== null,
      });
      this.$validator.extend("numbers", {
        getMessage: () => this.$t("errorMessage"),
        validate: (value) => value.match(/[0-9]/g) !== null,
      });
      this.$validator.extend("loCase", {
        getMessage: () => this.$t("errorMessage"),
        validate: (value) => value.match(/[a-z]/g) !== null,
      });
    },
    errorClass(rule) {
      return {
        error: this.errors.firstByRule("password", rule),
      };
    },
    /**
     * validate phone number
     */
    onInput({ number, isValid, country }) {
      this.users.contact_number = number["international"];
    },
    /**
     * vee validate with multi lang
     */
    loadLocale(code) {
      return import("vee-validate/dist/locale/" + code).then((locale) => {
        Validator.localize(code, locale);
      });
    },
    /**
     * append country code
     */
    appendCode() {
      if (this.users.contact_number.includes("+") == false) {
        this.users.contact_number =
          this.country + " " + this.users.contact_number;
      }
    },
    /**
     * Country Code
     */
    countryChanged(country) {
      this.country = "+" + country.dialCode;
    },
    handleUploading(form, xhr) {
      alert("hiii");
      this.message = "uploading...";
    },
    handleUploaded(response) {
      alert("response");
      if (response.status == "success") {
        this.user.avatar = response.url;
        // Maybe you need call vuex action to
        // update user avatar, for example:
        // this.$dispatch('updateUser', {avatar: response.url})
        this.message = "user avatar updated.";
      }
    },
    handleCompleted(response, form, xhr) {
      alert("responsesa");
      this.message = "upload completed.";
    },
    handlerError(message, type, xhr) {
      alert("responsecccc");
      console.log("message", message);
      this.message = "Oops! Something went wrong...";
    },
    /**
     * image validation
     */
    selectedFile(file) {
      this.error = "";
      var filePath = file.name;
      var allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
      if (!allowedExtensions.exec(filePath)) {
        this.error = this.$t("FileUploadError");
      } else {
        this.images = file;
        this.file_name = this.images.name;
        this.url = URL.createObjectURL(this.images);
        this.crop.src = URL.createObjectURL(this.images);
      }
    },

    /**
     *
     * checkForm    check profile form     **/
    checkForm() {
      this.handleSubmit();
    },
    /**
     *
     * handleSubmit    method  for submit data from profile form     **/

    handleSubmit() {
      this.success = "";
      this.error = "";
      this.submitted = true;
      this.users.password = this.newpassword;
      this.users.profile_image = this.images;
      this.$validator.validate().then((valid) => {
        if (valid) {
          if (this.newpassword == this.confirm_password) {
            this.show = true;
            let formData = new FormData();
            formData.append("id", this.users.id);
            formData.append("first_name", this.users.first_name);
            formData.append("last_name", this.users.last_name);
            formData.append("contact_number", this.users.contact_number);
            formData.append("profile_image", this.users.profile_image);
            formData.append("password", this.users.password);

            var data = {
              data: formData,
              id: this.users.id,
            };
            this.$store
              .dispatch("UpdateProfile", data)
              .then((response) => {
                this.show = false;
                this.crop.src = "";
                this.success = this.$t("ProfileUpdated");
                this.$toasted.show(this.success, {
                  className: "top-alert",
                  position: "top-center",
                  type: "success",
                  duration: 2000,
                });

                // this.users = response.data.data;
                if (response.data.data.profile_image.image) {
                  this.url = response.data.data.profile_image.path;
                }
                this.$router
                  .push({
                    path: "/admin/profile",
                  })
                  .catch(() => {});
              })
              .catch((error) => {
                this.show = false;
                // Error response
                this.error =
                  this.$t(error.replace(/[\s\/]/g, "")) !==
                  error.replace(/[\s\/]/g, "")
                    ? this.$t(error.replace(/[\s\/]/g, ""))
                    : error;
                this.$toasted.show(this.error, {
                  className: "top-alert",
                  position: "top-center",
                  type: "error",
                  duration: 2000,
                });
                return false;
              });
          } else {
            this.show = false;
            // Error
            this.error =
              this.$t(error.replace(/[\s\/]/g, "")) !==
              error.replace(/[\s\/]/g, "")
                ? this.$t(error.replace(/[\s\/]/g, ""))
                : error;
            this.$toasted.show(this.error, {
              className: "top-alert",
              position: "top-center",
              type: "error",
              duration: 2000,
            });
            return false;
          }
        }
      });
    },
    /**
     *
     *  getUsers   method  for get data login user     **/

    getUsers($id) {
      this.success = "";
      this.error = "";
      this.show = true;

      this.$store
        .dispatch("showProfile", $id)
        .then((res) => {
          this.show = false;
          this.users = res.data.data;

          if (res.data.data.profile_image.image) {
            this.url = res.data.data.profile_image.path;
          }
        })
        .catch((error) => {
          this.$log.error(
            "File : Add.vue | Function : getUsers() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
    cropImage() {
      const result = this.$refs.cropper.getResult();
      let obj = this;
      this.url = result.canvas.toDataURL(this.crop.type);
      this.urltoFile(
        result.canvas.toDataURL(this.crop.type),
        this.file_name,
        "image/*"
      ).then(function (file) {
        console.log("rahul--", file);
        obj.images = file;
        obj.uploadImage();
      });
      this.images = obj.images;
      this.crop.src = "";
    },

    uploadImage() {
      let formData = new FormData();
      formData.append("user_id", this.users.id);
      formData.append("user_role", "admin");
      formData.append("profile_image", this.images);
      formData.append("route_role", "superadmin");

      this.$store.dispatch("updateProfileImage", formData).then((response) => {
        this.show = false;
        this.crop.src = "";
        this.$store.getters.currentUser.profile_image =
          response.data.data.profile_image;
        this.$store.commit("SET_USER", this.$store.getters.currentUser);
        this.success = this.$t("ProfileImageUpdaeteSuccess");
        this.$toasted.show(this.success, {
          className: "top-alert",
          position: "top-center",
          type: "success",
          duration: 2000,
        });
      });
    },

    urltoFile(url, filename, mimeType) {
      return fetch(url)
        .then(function (res) {
          return res.arrayBuffer();
        })
        .then(function (buf) {
          return new File([buf], filename, { type: mimeType });
        });
    },
  },
};
</script>

<style>

.main {
    align-items: center;
    justify-content: center;
    text-align: center;
    background: #fff;
    border: 1px dashed #e2e8f0;
}

.dropzone-container {
    padding: 3rem;  
}

.hidden-input {
    opacity: 0;
    overflow: hidden;
    position: absolute;
    width: 1px;
    height: 1px;
}

.file-label {
    font-size: 15px;
    cursor: pointer;
}

.preview-container {
    display: flex;
    margin-top: 2rem;
}

#update {
  display: inline-flex;
}

#cancel {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  margin-left: 20px;
  margin-top: 20px;
}

.images {
  margin-top: 20px;
}

.contact_number {
  padding: 8px !important;
}

#contact_label {
  margin-top: 15px;
}

.btn-lg {
  border-radius: 5px;
  font-size: 14px;
  padding: 10px;
}

.button-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 17px;
}

.button {
  color: white;
  font-size: 16px;
  padding: 10px 20px;
  width: 100%;
  background: #151515;
  cursor: pointer;
  transition: background 0.5s;
  border: none;
}
</style>